import type { StackRouterProps } from "$root/components/common/Stack";
import type { ParameterizedConceptDTO, ConceptDefinitionDTO } from "@eu.mdotm.api/smart-workspaces";
import { WorkspaceCreateFilterStack, WorkspaceFilterSettingsStack } from "./WorkspaceFilterSettings";
import { defaultComparisonMode } from "./chain/WorkspaceFilterChain";
import { workspaceRepository } from "./repository";
import { formFromConcept } from "./concept-form";

export async function createFilterFromParametrizedConcept(
	sidePanelCtx: StackRouterProps,
	concept: ConceptDefinitionDTO,
	parametrizedConcept: ParameterizedConceptDTO,
) {
	const availableTagsConcepts = await workspaceRepository.getTagConceptDefinitions.fetchQuery();
	sidePanelCtx.push([
		WorkspaceFilterSettingsStack,
		() => (
			<WorkspaceCreateFilterStack
				title="Add filter"
				initialValue={{
					...formFromConcept(parametrizedConcept, concept, {
						tagConcepts: availableTagsConcepts,
						// A brand-new filter has no persisted label to compare the generated name against, so the
						// checkbox starts ticked and the name follows whatever the user picks next.
						autoGenerateName: true,
					}),
					// The filter's own half — here the *default* operator rather than a persisted one, since there
					// is no condition yet. The same rule the chain seeds a freshly picked concept with, so a
					// filter created from a column starts on the operator the panel would have offered.
					comparisonMode: defaultComparisonMode(concept),
				}}
			/>
		),
	]);
}
